import "core-js/modules/es.array.push.js";
import { defineStore } from 'pinia';
import store from '@/store';
import { get_dictionary, get_clue, quotation_review } from '@/api/apis';
export var useDicStore = defineStore('useDicStore', () => {
  var visit_list = ref('');
  var dis_s = ref([]);
  var clueCount = ref(0);
  var quoCount = ref(0);
  function get_quo_count() {
    // return new Promise((resolve, reject) => {
    var obj = {
      page: 1,
      limit: 200,
      todo_status: 1
    };
    quotation_review(obj).then(res => {
      if (res.code == 200) {
        quoCount.value = (res === null || res === void 0 ? void 0 : res.data.wait_check_count) || 0;
        console.log('quoCount,' + quoCount.value);
      }
    });
  }
  function get_visit_list() {
    return new Promise((resolve, reject) => {
      if (visit_list.value) {
        resolve(visit_list.value);
      } else {
        get_dictionary({
          full_name: '拜访方式'
        }).then(res => {
          if (res.code == 200) {
            visit_list.value = res.data.data;
            resolve(visit_list.value);
          }
        });
      }
    });
  }
  function get_clue_count() {
    // return new Promise((resolve, reject) => {
    var obj = {
      page: 1,
      limit: 200,
      thread_status: '未处理'
    };
    get_clue(obj).then(res => {
      if (res.code == 200) {
        var _res$data;
        clueCount.value = (res === null || res === void 0 || (_res$data = res.data) === null || _res$data === void 0 ? void 0 : _res$data.total) || 0;
      }
    });
    // })
  }
  function get_dic(val) {
    return new Promise((resolve, reject) => {
      var dic_item = dis_s.value.find(x => x.name == val);
      if (dic_item) {
        resolve(dic_item.arr);
      } else {
        get_dictionary({
          full_name: val
        }).then(res => {
          if (res.code == 200) {
            dis_s.value.push({
              name: val,
              arr: res.data.data
            });
            resolve(res.data.data);
          }
        });
      }
    });
  }
  return {
    get_visit_list,
    get_dic,
    get_clue_count,
    clueCount,
    quoCount,
    get_quo_count
  };
});

// 非setup
export function useDicStoreHook() {
  return useDicStore(store);
}